import { StyleSheet } from 'react-native';

import { CellType } from '../../RecyclerGridView/types';
import { EPGConfig } from '../../types';

const getStyles = (config: EPGConfig, type: CellType) =>
    StyleSheet.create({
        cell: {
            flex: 1,
            justifyContent: 'center',
            marginBottom: config.padding,
            marginRight:
                type === CellType.Program || type === CellType.MissingData
                    ? config.padding
                    : 0,
            borderRadius: config.cellBorderRadius,
        },
    });

export default getStyles;
